<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/ai-call-summary-software.mjs";
</script>
